import styled from 'styled-components';
import { theme, palette } from 'styled-tools';

export const CaptionWrapper = styled.div`
    padding: 16px 0;
    text-align: center;
    ${theme('fontStyle.body2')}
    color: ${palette('gray_opacity_600')};
`;
